<script setup lang="ts">
</script>

<template>
  <div class="flex flex-col items-center justify-center p-16">
    <div class="mb-4">
      <slot name="icon">
        <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" class="w-16">
          <path class="fill-current text-gray-100" d="M12 2a10 10 0 1 1 0 20 10 10 0 0 1 0-20z" />
          <path
            class="fill-current text-gray-500"
            d="M11 12a1 1 0 0 1 0-2h2a1 1 0 0 1 .96 1.27L12.33 17H13a1 1 0 0 1 0 2h-2a1 1 0 0 1-.96-1.27L11.67 12H11zm2-4a1.5 1.5 0 1 1 0-3 1.5 1.5 0 0 1 0 3z"
          />
        </svg>
      </slot>
    </div>
    <div class="text-2xs text-gray-400 text-center">
      <slot name="text">
        {{ $t('common.datatable.empty') }}
      </slot>
    </div>
    <slot />
  </div>
</template>